/**
 * company-email.js — ô email của 3 form RFQ chỉ nhận email công ty.
 *
 * Bản trên server mới là bản có quyền quyết định (rfq/email.php + rfq/validate.php);
 * file này chỉ để khách biết NGAY lúc gõ, thay vì gửi đi rồi mới bị đá về và phải cuộn
 * lại tìm ô đỏ. Cả hai bên dùng chung một danh sách tên miền và chung một cách khớp.
 *
 * Bật bằng `data-company-email` trên ô input — thuộc tính đó đồng thời chứa CHỮ ĐÃ DỊCH,
 * cùng cách làm với `data-loading-label` ở form-loading.js: bundle này do gulp build sẵn
 * nên không đọc được bản dịch của WordPress.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var inputs = [].slice.call(document.querySelectorAll('input[data-company-email]'));
    if (!inputs.length) return;

    /*
     * WordPress in `window.onsmaxFreeEmailDomains` ra TRƯỚC bundle này (rfq/email.php),
     * lấy từ Theme Options — đó mới là nguồn sự thật. Danh sách dưới đây chỉ để bản HTML
     * tĩnh trong html/ (không có PHP) vẫn demo được đúng hành vi.
     */
    var FALLBACK = [
        'gmail.com', 'googlemail.com', 'yahoo.*', 'ymail.com', 'hotmail.*', 'outlook.*',
        'live.*', 'msn.com', 'aol.com', 'icloud.com', 'me.com', 'gmx.*', 'mail.com',
        'proton.me', 'protonmail.com', 'zoho.com', 'yandex.*', 'mail.ru', 'qq.com',
        '163.com', '126.com', 'naver.com', 'daum.net', 'rediffmail.com', 'mailinator.com',
        'yopmail.com', 'guerrillamail.com', '10minutemail.com', 'temp-mail.org',
        'tempmail.com', 'trashmail.com', 'maildrop.cc', 'getnada.com'
    ];

    var list = window.onsmaxFreeEmailDomains;
    var domains = list && list.length ? list : FALLBACK;

    function domainOf(value) {
        var at = value.lastIndexOf('@');
        return at === -1 ? '' : value.slice(at + 1).toLowerCase().replace(/\.+$/, '');
    }

    // Khớp y hệt onsmax_rfq_email_domain_is_free() bên PHP: `yahoo.*` khớp mọi đuôi của
    // cùng nhà cung cấp, tên miền thường khớp cả tên miền con của nó.
    function isFree(domain) {
        for (var i = 0; i < domains.length; i++) {
            var pattern = String(domains[i]).toLowerCase();

            if (pattern.slice(-2) === '.*') {
                var base = pattern.slice(0, -2);
                if (domain === base || domain.indexOf(base + '.') === 0) return true;
                continue;
            }

            if (domain === pattern || domain.slice(-(pattern.length + 1)) === '.' + pattern) return true;
        }

        return false;
    }

    /*
     * Chỉ xét khi địa chỉ đã đủ dạng `ten@ten-mien.tld`. Gõ dở dang thì im lặng, và sai
     * ĐỊNH DẠNG cũng im lặng: chỗ đó để server báo, ở đây báo nữa là hai giọng khác nhau
     * cho cùng một ô.
     */
    function isComplete(value) {
        return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(value);
    }

    function field(input) {
        return input.closest ? input.closest('.field') : null;
    }

    function errorNode(input, message) {
        var wrap = field(input);
        if (!wrap) return null;

        var node = wrap.querySelector('.field__error');

        if (!node) {
            node = document.createElement('div');
            node.className = 'field__error';
            wrap.appendChild(node);
        }

        node.textContent = message;
        return node;
    }

    function clearError(input) {
        var wrap = field(input);

        input.setCustomValidity('');
        input.removeAttribute('aria-invalid');

        if (!wrap) return;

        wrap.classList.remove('field--error');

        // Gỡ hẳn khỏi DOM chứ không để rỗng: `.field` xếp dọc bằng `gap`, một thẻ rỗng
        // vẫn ăn đúng 7px và để lại khoảng hở không ai giải thích được.
        var node = wrap.querySelector('.field__error');
        if (node) node.parentNode.removeChild(node);
    }

    function showError(input) {
        var wrap = field(input);
        var message = input.getAttribute('data-company-email');

        // setCustomValidity: rfq.js mở/khoá nút gửi theo form.checkValidity(), nên đây là
        // cách duy nhất để ô này cũng khoá được nút đó.
        input.setCustomValidity(message);
        input.setAttribute('aria-invalid', 'true');

        if (wrap) wrap.classList.add('field--error');
        errorNode(input, message);
    }

    // true = hợp lệ (hoặc chưa đủ dữ liệu để kết luận).
    function check(input) {
        var value = input.value.trim();

        if (!isComplete(value) || !isFree(domainOf(value))) {
            clearError(input);
            return true;
        }

        showError(input);
        return false;
    }

    inputs.forEach(function (input) {
        // `blur` chứ không phải `input`: bắt lỗi ngay từ ký tự đầu của "gmail.com" là báo
        // đỏ vào mặt người đang gõ dở "…@gmail-solutions.vn".
        input.addEventListener('blur', function () {
            check(input);
        });

        // Đang sửa thì gỡ báo lỗi ngay, không bắt chờ tới lúc rời ô.
        input.addEventListener('input', function () {
            if (input.value.trim() === '' || !isFree(domainOf(input.value.trim()))) clearError(input);
        });
    });

    /*
     * Chặn lúc gửi: cả 3 form đều `novalidate` nên trình duyệt không tự chặn, phải tự làm.
     *
     * Bắt ở `document` pha CAPTURE chứ không phải trên chính form: form-loading.js cũng
     * nghe `submit` của form đó và bật trạng thái "đang gửi" vô điều kiện. Chặn ở pha
     * capture thì `stopPropagation()` khiến sự kiện không bao giờ tới listener kia, nên
     * nút không bị khoá + xoay mãi trong khi form đã dừng lại. Cách này không phụ thuộc
     * thứ tự gộp file của gulp, khác với việc trông chờ listener nào đăng ký trước.
     */
    document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form || !form.querySelectorAll) return;

        var fields = [].slice.call(form.querySelectorAll('input[data-company-email]'));
        if (!fields.length) return;

        var invalid = null;

        fields.forEach(function (input) {
            if (!check(input) && !invalid) invalid = input;
        });

        if (!invalid) return;

        event.preventDefault();
        event.stopPropagation();
        invalid.focus();
    }, true);
})();
